import '../scss/app.scss';
import './newsletter';

var $ = jQuery;

var bgImages = new Array();
function getBGSize() {
    var def = $.Deferred();
    var totalBG = $('.section-quote').length;
    $('.section-quote').each(function(j) {
        var w = $(this).width();
        var $that = $(this);
        var url = $(this).css('background-image').replace('url(', '').replace(')', '').replace("'", '').replace('"', '').replace('"', '');
        var bgImg = $('<img />');
        bgImg.hide();
        bgImg.bind('load', function() {
            bgImages.push({
                elem: $that,
                height:	$(this).height(),
                width:$(this).width()
            });
            if (j == totalBG-1) {
                def.resolve();
            }
        });
        $(this).append(bgImg);
        bgImg.attr('src', url);
    });

    return def;
}

function setBGSize() {
    for(var i = 0; i < bgImages.length; i++) {
        bgImages[i].elem.css('height', (bgImages[i].height / bgImages[i].width) * bgImages[i].elem.width());
    }
}

$(document).ready(function() {
    getBGSize().done(setBGSize);
});
$(window).resize(function() {
    getBGSize().done(setBGSize);
});

function setBackToTopArrow() {
    if($(window).scrollTop() > 100) {
        $('a.link-top').removeClass('hidden');
    }
    else {
        $('a.link-top').addClass('hidden');
    }
}

jQuery(document).ready(function($) {
	$('.slider-home').slick({
		autoplay: true,
		autoplaySpeed: 10000,
		infinite: true
	});

    setBackToTopArrow();

    $('a.link-top').click(function(e) {
        e.preventDefault();
        $('html, body').stop().animate({ scrollTop: 0 });
    });

    $('p iframe[src*="youtube"]').parent().fitVids({ maxWidth: true });
    $('p iframe[src*="vimeo"]').parent().fitVids({ maxWidth: true });
});
jQuery(document).scroll(function() {
    setBackToTopArrow();
});


jQuery(window).resize(function() {
  var more = document.getElementsByClassName("menu-item-has-children");
  if (jQuery(more).length > 0) {
    var windowWidth = $(window).width();
    var moreLeftSideToPageLeftSide = $(more).offset().left;
    var moreLeftSideToPageRightSide = windowWidth - moreLeftSideToPageLeftSide;

    if (moreLeftSideToPageRightSide < 330) {
      jQuery(".menu-item-has-children .sub-menu .sub-menu").removeClass("fly-out-right");
      jQuery(".menu-item-has-children .sub-menu .sub-menu").addClass("fly-out-left");
    }

    if (moreLeftSideToPageRightSide > 330) {
      jQuery(".menu-item-has-children .sub-menu .sub-menu").removeClass("fly-out-left");
      jQuery(".menu-item-has-children .sub-menu .sub-menu").addClass("fly-out-right");
    }
  }
});

jQuery(document).ready(function() {
  var menuToggle = jQuery("#js-mobile-menu").unbind();
  jQuery("#js-navigation-menu").removeClass("show");

  menuToggle.on("click", function(e) {
    e.preventDefault();
    jQuery("#js-navigation-menu").slideToggle(function(){
      if(jQuery("#js-navigation-menu").is(":hidden")) {
        jQuery("#js-navigation-menu").removeAttr("style");
      }
    });
  });
});

jQuery(document).ready(function($) {
    $('.section-priceboxes input[name="billing"]').change(function() {
        if($(this).prop('checked')) {
            $('.section-priceboxes span.pricing').html(priceAnnually);
        }
        else {
            $('.section-priceboxes span.pricing').html(priceMonthly);
        }
    });
    $('.section-priceboxes .pricing-box-button').click(function(e) {
        if($(this).attr('href').indexOf('#') > -1) {
            var el = $($(this).attr('href'));
            if(el.length > 0) {
                e.preventDefault();
                $('html, body').stop().animate({ scrollTop: el.offset().top });
            }
        }
    });
});

jQuery(document).ready(function($) {
    $('.menu-item-has-children > a').click(function(e) {
        e.preventDefault();
        if ($(window).width() > 930) {
            return;
        }
        const container = $(this).parent();
        const subMenu = container.find('ul.sub-menu');
        if (container.hasClass('menu-open')) {
            container.removeClass('menu-open');
            subMenu.slideUp();
        } else {
            container.addClass('menu-open');
            subMenu.slideDown();
        }
    });
});

jQuery(document).ready(function($) {
    $('.grid-switch-button').click(function(e) {
        e.preventDefault();
        const el = $(this).closest('.section-grid').find('.blog-wrapper');
        console.log(el);
        if (el.hasClass('open')) {
            el.slideUp();
            el.removeClass('open');
            $(this).html($(this).data('show-text'));
        } else {
            el.slideDown();
            el.addClass('open');
            $(this).html($(this).data('hide-text'));
        }
    });
});



// WEBPACK FOOTER //
// ./src/js/app.js